import { Modal } from "react-bootstrap";
import Button from "../Button";
const convertToHtml = (data) => {
    return <div dangerouslySetInnerHTML={{ __html: data }}></div>
}
const SuccesModal = (props) =>{
    const {
        color,
        content,
        handleClose
    } = props
return(
    <Modal
            size="md sm xs"
            show={true}
            keyboard={false}
            dialogClassName="popTimeOut"
            className="z-index-alertMessage"
            backdropClassName="z-index-alertMessage-backdrop"
        >
            <div style={{ borderLeft: `5px solid ${color}` }}>
                <Modal.Body>
                    <div>
                        {convertToHtml(content)}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button text="OK" customColor={color} action={() => { handleClose(false) }} />
                </Modal.Footer>
            </div>
        </Modal>
    )
}
export default SuccesModal;